export default __webpack_public_path__ + "static/media/welcome.c4c2839f.gif";